import React, { Component } from 'react'
import '../styles/OrganizationalProfile.css'
import DropdownWidget from '../widgets/DropdownWidget'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import OrgFooter from '../widgets/OrgFooter'
import APIGenericRequest from '../api/APIGenericRequest'
import APIOrganizationRequest from '../api/APIOrganizationRequest'
import APIOtherProjectRequest from '../api/APIOtherProjectRequest'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import DatePicker from '../widgets/DatePicker'

class OrganizationalProfile extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			arboId: sessionStorage.getItem("arbo-id"),
			itemObj: {},
			keyTracer: 0,
			services: [],
			servicesOffered: {},
			addServicesOffered: {},
			deleteServicesOffered: {},

			itemObjOP: {},
			keyTracerOP: 0,
			otherProjects: [],
			otherProjectsCurrent: {},
			addOtherProjects: {},
			deleteOtherProjects: {},

			dateToday: sessionStorage.getItem("date-today"),
			partnershipType: "-- SELECT --",
			province: "-- SELECT --",
			city: "-- SELECT --",
			arboType: "-- SELECT --",
			shouldDisplayValues: props.displayValues,
			isViewDetails: props.isViewDetails
		}
		this.eventHandler = this.eventHandler.bind(this)
		this.eventHandlerOP = this.eventHandlerOP.bind(this)
		this.setAllFieldsDisabled = this.setAllFieldsDisabled.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.getProvinces = this.getProvinces.bind(this)
		this.getARBOCategories = this.getARBOCategories.bind(this)
		this.getARBOTypes = this.getARBOTypes.bind(this)
		this.setScrollable = this.setScrollable.bind(this)
		this.getFormValues = this.getFormValues.bind(this)
		this.setSessionProps = this.setSessionProps.bind(this)
		this.setServiceOffered = this.setServiceOffered.bind(this)
		this.requiredInputAlertMessage = this.requiredInputAlertMessage.bind(this)
	}

	onSubmit() {
		// if(this.state.orgID == null || this.state.orgID === '') {
		// 	this.requiredInputAlertMessage("Organization ID")
		// 	return
		// }
		if(this.state.orgName == null || this.state.orgName === '') {
			this.requiredInputAlertMessage("Organization Name")
			return
		}
		if(this.state.categoryId == null) {
			this.requiredInputAlertMessage("Partnership Type")
			return
		}
		if(this.state.provinceId == null) {
			this.requiredInputAlertMessage("Province")
			return
		}
		if(this.state.cityId == null) {
			this.requiredInputAlertMessage("Municipality")
			return
		}
		this.setState({showActivityIndicator: true})
		const servicesOffered = []
		Object.values(this.state.servicesOffered).forEach((v => {
			servicesOffered.push(v)
		}))
		const addServicesOffered = []
		Object.values(this.state.addServicesOffered).forEach((v => {
			addServicesOffered.push(v)
		}))
		const deleteServicesOffered = []
		Object.values(this.state.deleteServicesOffered).forEach((v => {
			deleteServicesOffered.push(v)
		}))
		let assets = this.state.assets?.replace(/,/g, "")
		let liabilities = this.state.liabilities?.replace(/,/g, "")
		console.log('assets', assets, liabilities)
		if(assets == null) {
			assets = 0.00
		}
		if(liabilities == null) {
			liabilities = 0.00
		}
		const data = {
			organization: {
				name: this.state.orgName,
				region_id: this.state.user.region_id,
				province_id: this.state.provinceId,
				city_id: this.state.cityId,
				site_id: JSON.parse(localStorage.getItem("siteId")),
				category_id: this.state.categoryId,
				arc_name: this.state.arcName,
				organization_id: this.state.orgID,
			},
			generalInformation: {
				date_organized: this.state.dateOrganized,
				arbo_type_id: this.state.typeId,
				registering_agency: this.state.agency,
				registration_issuance_date: this.state.issuanceDate,
				bod_chair_name: this.state.chairName,
				bod_contact_no: this.state.bodNumber
			},
			servicesOffered: servicesOffered,
			financialPerformance: {
				assets: parseFloat(assets),
				liabilities: parseFloat(liabilities)
			}
		}
		// assets: this.state.assets?.replace(/,/g, ""),
		// liabilities: this.state.liabilities?.replace(/,/g, "")

		if(addServicesOffered.length > 0) {
			data["add"] = {servicesOffered: addServicesOffered}
		}
		if(deleteServicesOffered.length > 0) {
			data["delete"] = {servicesOffered: deleteServicesOffered}
		}
		console.log('data -->', data)
		if(!this.state.shouldDisplayValues) {
			const apiReq = APIOrganizationRequest.addOrganization(this.state.accessToken, data)
			apiReq.then((response) => {
				console.log('addOrganization', response)
				if(response.status === "FAILED") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				if(response.status === "ERROR") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.error,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					arboId: response.results.arbo_id,
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					submitAdd: false,
					showActivityIndicator: false
				})
				this.setSessionProps(this.state.arboId, data)
			})
		}
		else {
			const arboId = sessionStorage.getItem("arbo-id")
			const apiReq = APIOrganizationRequest.editOrganization(this.state.accessToken, data, this.state.arboId)
			apiReq.then((response) => {
				console.log('editOrganization', response)
				if(response.status === "FAILED") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				if(response.status === "ERROR") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.error,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					showActivityIndicator: false,
					addServicesOffered: {},
					deleteServicesOffered: {},
				})
			})
		}
	}

	requiredInputAlertMessage(str) {
		this.setState({
			showWarningMessage: true,
			aMessage: `${str} is required. All fields with the asterisk (*) symbol must have values.`
		})
	}

	setSessionProps(arboId, data) {
		sessionStorage.setItem("arbo-id", arboId)
		sessionStorage.setItem("organization", data.organization)
		sessionStorage.setItem("generalInformation", data.generalInformation)
		sessionStorage.setItem("servicesOffered", data.servicesOffered)
		sessionStorage.setItem("financialPerformance", data.financialPerformance)
		sessionStorage.setItem("mfTrack", data.mfTrack)
	}

	setAllFieldsDisabled(v) {
		const fields = document.querySelectorAll('#org-client-area *')
		for(const f of fields) {
			f.disabled = v
		}
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "service":
				if(this.state.servicesOffered == null) {
					this.state.servicesOffered = {}
				}
				this.state.servicesOffered[compId] = value
				break
			case "add":
				this.state.addServicesOffered[compId] = value
				const added = []
				const k = "li-" + this.state.keyTracer
				this.state.itemObj[k] = <ServiceOffered handler={this.eventHandler} key={k} id={k} />
				this.state.keyTracer++
				Object.keys(this.state.itemObj).forEach((k => {
					added.push(this.state.itemObj[k])
				}))
				this.setState({services: added})
				break
			case "delete":
				this.state.deleteServicesOffered[compId] = value
				delete this.state.servicesOffered[compId]
				delete this.state.itemObj[compId]
				const deleted = []
				Object.keys(this.state.itemObj).forEach((k => {
					deleted.push(this.state.itemObj[k])
				}))
				this.setState({services: deleted})
		}
	}

	eventHandlerOP(e, compId, key, value) {
		switch(e) {
			case "project":
				if(this.state.otherProjectsCurrent == null) {
					this.state.otherProjectsCurrent = {}
				}
				this.state.otherProjectsCurrent[compId] = value
				break
			case "add":
				this.state.addOtherProjects[compId] = value
				const added = []
				const k = "op-" + this.state.keyTracerOP
				this.state.itemObjOP[k] = <OtherProject handler={this.eventHandlerOP} key={k} id={k} />
				this.state.keyTracerOP++
				Object.keys(this.state.itemObjOP).forEach((k => {
					added.push(this.state.itemObjOP[k])
				}))
				this.setState({otherProjects: added})
				break
			case "delete":
				this.state.deleteOtherProjects[compId] = value
				delete this.state.otherProjectsCurrent[compId]
				delete this.state.itemObjOP[compId]
				const deleted = []
				Object.keys(this.state.itemObjOP).forEach((k => {
					deleted.push(this.state.itemObjOP[k])
				}))
				this.setState({otherProjects: deleted})
		}
	}

	componentWillMount() {
		this.getProvinces()
		this.getARBOCategories()
		this.getARBOTypes()
		if(this.state.shouldDisplayValues) {
			this.getFormValues()
		}
		else {
			const k = "li-" + this.state.keyTracer
			this.state.itemObj[k] = <ServiceOffered handler={this.eventHandler} key={k} id={k} />
			this.state.keyTracer++
			this.state.services.push(this.state.itemObj[k])
		}
	}

	getFormValues() {
		this.setState({showActivityIndicator: true})
		const org = APIOrganizationRequest.getOrganizationById(this.state.accessToken, this.state.arboId)
		org.then((response) => {
			console.log('getOrganizationById ==>', response)
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			const stateProps = {
				arboId: response.results.organization.arbo_id,
				orgName: response.results.organization.name,
				partnershipType: response.results.organization.category,
				province: response.results.organization.province,
				city: response.results.organization.city,
				arcName: response.results.organization.arc_name,
				orgID: response.results.organization.organization_id,
				categoryId: response.results.organization.category_id,
				provinceId: response.results.organization.province_id,
				cityId: response.results.organization.city_id,
				showActivityIndicator: false
			}
			if(response.results.generalInformation != null) {
				stateProps["dateOrganized"] = response.results.generalInformation.date_organized
				stateProps["arboType"] = response.results.generalInformation.arbo_type
				stateProps["agency"] = response.results.generalInformation.registering_agency
				stateProps["issuanceDate"] = response.results.generalInformation.registration_issuance_date
				stateProps["chairName"] = response.results.generalInformation.bod_chair_name
				stateProps["bodNumber"] = response.results.generalInformation.bod_contact_no
			}
			if(response.results.financialPerformance != null) {
				const assets = (response.results.financialPerformance.assets == 0)? null: + response.results.financialPerformance.assets + ""
				const liabilities = (response.results.financialPerformance.liabilities == 0)? null: response.results.financialPerformance.liabilities + ""
				stateProps["assets"] = assets?.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
				stateProps["liabilities"] = liabilities?.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
			}
			this.setState(stateProps)
			this.setServiceOffered(response.results.servicesOffered)
			this.setOtherProjects()
		})
	}

	setServiceOffered(servicesOffered) {
		const services = []
		if(servicesOffered != null) {
			for(const v of servicesOffered) {
				const k = "li-" + this.state.keyTracer
				this.state.itemObj[k] = <ServiceOffered data={v} handler={this.eventHandler}
					disabled={this.state.isViewDetails} key={k} id={k} />
				this.state.keyTracer++
			}
			const k = "li-" + this.state.keyTracer
			this.state.itemObj[k] = <ServiceOffered handler={this.eventHandler}
				disabled={this.state.isViewDetails} key={k} id={k} />
			this.state.keyTracer++
			Object.keys(this.state.itemObj).forEach((k => {
				services.push(this.state.itemObj[k])
			}))
		}
		else {
			const k = "li-" + this.state.keyTracer
			this.state.itemObj[k] = <ServiceOffered handler={this.eventHandler} key={k} id={k} />
			this.state.keyTracer++
			services.push(this.state.itemObj[k])
		}
		this.setState({services: services})
	}

	setOtherProjects(projects) {
		const otherProjects = []
		if(projects != null) {
			for(const v of projects) {
				const k = "li-" + this.state.keyTracer
				this.state.itemObj[k] = <OtherProject data={v} handler={this.eventHandlerOP}
					disabled={this.state.isViewDetails} key={k} id={k} />
				this.state.keyTracer++
			}
			const k = "li-" + this.state.keyTracer
			this.state.itemObj[k] = <OtherProject handler={this.eventHandlerOP}
				disabled={this.state.isViewDetails} key={k} id={k} />
			this.state.keyTracer++
			Object.keys(this.state.itemObj).forEach((k => {
				otherProjects.push(this.state.itemObj[k])
			}))
		}
		else {
			const k = "li-" + this.state.keyTracer
			this.state.itemObj[k] = <OtherProject handler={this.eventHandlerOP} key={k} id={k}
				disabled={this.state.isViewDetails} />
			this.state.keyTracer++
			otherProjects.push(this.state.itemObj[k])
		}
		this.setState({otherProjects: otherProjects})
	}

	getProvinces() {
		const provs = JSON.parse(localStorage.getItem("provinces"))
		if(provs != null) {
			this.setState({provinces: provs})
			return
		}
		const province = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, this.state.user.region_id)
		province.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.province_id, name: v.name})
			}
			localStorage.setItem("provinces", JSON.stringify(c))
			this.setState({
				provinces: c,
				provincePlaceholder: "-- SELECT --",
				cityPlaceholder: "-- SELECT --"
			})
		})
	}

	getARBOCategories() {
		const c = JSON.parse(localStorage.getItem("arbo-categories"))
		if(c != null) {
			this.setState({categories: c})
			return
		}
		const categories = APIOrganizationRequest.getAllARBOCAtegories(this.state.accessToken)
		categories.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.category_id, name: v.name})
			}
			localStorage.setItem("arbo-categories", JSON.stringify(c))
			this.setState({categories: c})
		})
	}

	getARBOTypes() {
		const c = JSON.parse(localStorage.getItem("arbo-types"))
		if(c != null) {
			this.setState({types: c})
			return
		}
		const types = APIOrganizationRequest.getAllARBOTypes(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.arbo_type_id, name: v.name})
			}
			localStorage.setItem("arbo-types", JSON.stringify(c))
			this.setState({types: c})
		})
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize.bind(this))
		this.setScrollable()
		this.setAllFieldsDisabled(this.state.isViewDetails)
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize.bind(this))
	}

	onResize() {
			this.setScrollable()
	}

	setScrollable() {
		const sa = document.getElementById('org-scroll-area')
		const ca = document.getElementById('org-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+54) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const view = <div id="org-profile">
			<div className="title-bar">ORGANIZATION PROFILE</div>
			<div id="org-scroll-area"><div id="org-client-area">
				<div id="osa-cell1">
					<div id="osa-cell1-r1">
						<div id="osa-cell1-r1-i0">
							<div>Organization ID</div>
							<input type="text" value={this.state.orgID} onChange={(e) => {
								this.setState({orgID: e.target.value})
							}} />
						</div>
						<div id="osa-cell1-r1-i1">
							<div>* Organization Name</div>
							<input type="text" value={this.state.orgName} onChange={(e) => {
								this.setState({orgName: e.target.value})
							}} />
						</div>
						<div id="osa-cell1-r1-i2">
							<div>* Partnership Type</div>
							<DropdownWidget list={this.state.categories} placeholder={this.state.partnershipType} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									this.setState({categoryId: id})
								}} />
						</div>
					</div>
					<div id="osa-cell1-r2">
						<div id="osa-cell1-r2-i1">
							<div>* Province</div>
							<DropdownWidget list={this.state.provinces} placeholder={this.state.province} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									this.setState({provinceId: id})
									const province = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, id)
									province.then((response) => {
										if(response.status === "FAILED") {
											return
										}
										const c = []
										for(const v of response.results.rows) {
											c.push({id: v.city_id, name: v.name})
										}
										this.setState({
											cities: c,
											cityPlaceholder: "-- SELECT --"
										})
									})
								}} />
						</div>
						<div id="osa-cell1-r2-i2">
							<div>* Municipality</div>
							<DropdownWidget list={this.state.cities} placeholder={this.state.city} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									this.setState({cityId: id})
								}} />
						</div>
						<div id="osa-cell1-r2-i3">
							<div>Name of Agrarian Reform Community</div>
							<input type="text" value={this.state.arcName} onChange={(e) => {
								this.setState({arcName: e.target.value})
							}} />
						</div>
					</div>
				</div>
				<div id="osa-flex">
				<div id="osa-left">
					<div id="osa-cell2">
						<div style={{'flex-basis': '100%', 'font-family':'roboto-bold'}}>GENERAL INFORMATION</div>
						<div id="osa-cell2-i1">
							<div style={{'margin-bottom': '5px'}}>Date Organized</div>
							<DatePicker value={this.state.dateOrganized} onChange={(value) => {
								this.setState({dateOrganized: value})
							}} max={this.state.dateToday} />
						</div>
						<div id="osa-cell2-i2">
							<div style={{'margin-bottom': '5px'}}>ARBO Type</div>
							<DropdownWidget list={this.state.types} placeholder={this.state.arboType} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									this.setState({typeId: id})
								}} />
						</div>
						<div id="osa-cell2-i3">
							<div>Registering Agency</div>
							<input type="text" value={this.state.agency} onChange={(e) => {
								this.setState({agency: e.target.value})
							}} />
						</div>
						<div id="osa-cell2-i4">
							<div style={{'margin-bottom': '5px'}}>Date of Issuance of Registration</div>
							<DatePicker value={this.state.issuanceDate} onChange={(value) => {
								this.setState({issuanceDate: value})
							}} max={this.state.dateToday} />
						</div>
						<div id="osa-cell2-i5">
							<div>BOD Chair Name</div>
							<input type="text" value={this.state.chairName} onChange={(e) => {
								this.setState({chairName: e.target.value})
							}} />
						</div>
						<div id="osa-cell2-i6">
							<div>BOD Contact Number</div>
							<input type="text" value={this.state.bodNumber} onChange={(e) => {
								const checker = /^[0-9+]{11}$/
								const isValid = checker.test(e.target.value)
								if(isValid) {
									this.setState({bodNumber: e.target.value})
									e.target.value = e.target.value
								}
								else {
									if(isNaN(parseInt(e.target.value))) {
										e.target.value = ""
										this.setState({bodNumber: ''})
									}
									else if(e.target.value.length > 10) {
										e.target.value = parseInt(e.target.value.substring(0, 10))
									}
									else {
										e.target.value = parseInt(e.target.value)
									}
								}
							}} />
						</div>
					</div>
					<div id="osa-cell5">
						<div style={{'margin-left': '15px',  'font-family':'roboto-bold'}}>SERVICE OFFERED</div>
						<div id="osa-services">{this.state.services}</div>
					</div>
				</div>
				<div id="osa-right">
					<div id="osa-cell3">
						<div style={{'flex-basis': '100%', 'font-family':'roboto-bold'}}>FINANCIAL PERFORMANCE</div>
						<div id="osa-cell3-i1">
							<div>Assets</div>
							<input type="text" value={this.state.assets} placeholder='0.00' onChange={(e) => {
								if(isCurrencyValid(e.target.value)) {
									const v = e.target.value.replace(/,/g, "")
									this.setState({assets: formatCurrency(e.target.value)})
								}
								else {
									if(isNaN(parseInt(e.target.value))) {
										e.target.value = ""
										this.setState({assets: ''})
									}
									else {
										const v = e.target.value.replace(/,/g, "")
										e.target.value = parseInt(v)
										e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
									}
								}
							}} />
						</div>
						<div id="osa-cell3-i2">
							<div>Liabilities</div>
							<input type="text" value={this.state.liabilities} placeholder='0.00' onChange={(e) => {
								if(isCurrencyValid(e.target.value)) {
									const v = e.target.value.replace(/,/g, "")
									console.log('format currency', formatCurrency(e.target.value))
									this.setState({liabilities: formatCurrency(e.target.value)})
								}
								else {
									if(isNaN(parseInt(e.target.value))) {
										e.target.value = ""
										this.setState({liabilities: ''})
									}
									else {
										const v = e.target.value.replace(/,/g, "")
										e.target.value = parseInt(v)
										e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
									}
								}
							}} />
						</div>
					</div>
					{/* <div id="osa-cell5">
						<div style={{'margin-left': '15px',  'font-family':'roboto-bold'}}>OTHER PROJECTS</div>
						<div id="osa-services">{this.state.otherProjects}</div>
					</div> */}
				</div>
				</div>
			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				showSubmit={true} disabled={this.state.isViewDetails} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer">
					<OrgFooter submit={this.onSubmit} disabled={this.state.isViewDetails} showSubmit={true} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false, shouldDisplayValues: true})
					this.props.submit()
			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class ServiceOffered extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			disabled: props.disabled,
			serviceData: {},
			service: "-- SELECT --"
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		this.getARBOServices = this.getARBOServices.bind(this)
	}

	componentWillMount() {
		this.getARBOServices()
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.serviceData["id"] = this.props.data.id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIconGray} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				service: this.props.data.arbo_service,
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIconGray} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.serviceData)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove service ${this.state.service}?`
		})
	}

	getARBOServices() {
		const c = JSON.parse(localStorage.getItem("services"))
		if(c != null) {
			this.setState({services: c})
			return
		}
		const resp = APIOrganizationRequest.getAllARBOServices(this.state.accessToken)
		resp.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.arbo_service_id, name: v.name})
			}
			localStorage.setItem("services", JSON.stringify(c))
			this.setState({services: c})
		})
	}

	render() {
		const view = <div className="service-offered">
			<div>{this.state.addDeleteButton}</div>
			<DropdownWidget list={this.state.services} placeholder={this.state.service}
				cStyle={{"width": "calc(100% - 5px)"}} onItemSelected={(id, val) => {
					this.state.serviceData["arbo_service_id"] = id
					this.props.handler("service", this.state.itemId, null, this.state.serviceData)
					if(this.state.addDeleteButton.props.alt == "ADD") {
						this.onAddItemClick()
					}
				}} disabled={this.state.disabled} />
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					this.setState({showConfirmMessage: false})
					if(e.target.innerHTML === "NO") {
					}
					else {
						this.props.handler("delete", this.state.itemId, null, this.state.serviceData)
					}
			}} />}
		</div>
		return(view)
	}
}

class OtherProject extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			disabled: props.disabled,
			projectData: {},
			project: "-- SELECT --"
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		this.getOtherProjects = this.getOtherProjects.bind(this)
	}

	componentWillMount() {
		this.getOtherProjects()
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.projectData["id"] = this.props.data.id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIconGray} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				service: this.props.data.arbo_service,
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIconGray} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.projectData)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to delete project ${this.state.service}?`
		})
	}

	getOtherProjects() {
		const c = JSON.parse(localStorage.getItem("projects"))
		if(c != null) {
			this.setState({projects: c})
			return
		}
		const resp = APIOtherProjectRequest.getAllOtherProjects(this.state.accessToken)
		resp.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.project_id, name: v.project_name})
			}
			localStorage.setItem("projects", JSON.stringify(c))
			this.setState({projects: c})
		})
	}

	render() {
		const view = <div className="service-offered">
			<div>{this.state.addDeleteButton}</div>
			<DropdownWidget list={this.state.projects} placeholder={this.state.project}
				cStyle={{"width": "calc(100% - 5px)"}} onItemSelected={(id, val) => {
					this.state.projectData["project_name"] = id
					this.props.handler("project", this.state.itemId, null, this.state.projectData)
					if(this.state.addDeleteButton.props.alt == "ADD") {
						this.onAddItemClick()
					}
				}} disabled={this.state.disabled} />
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					this.setState({showConfirmMessage: false})
					if(e.target.innerHTML === "NO") {
					}
					else {
						this.props.handler("delete", this.state.itemId, null, this.state.projectData)
					}
			}} />}
		</div>
		return(view)
	}
}

const formatCurrency = (value) => {
	console.log(value)
	const v = value.replace(/,/g, "")
	const c = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	return(c)
}

const isCurrencyValid = (value) => {
	const checker = /^[\d,]+\.?\d{0,2}?$/
	const isValid = checker.test(value)
	return(isValid)
}

export default OrganizationalProfile
